export default __webpack_public_path__ + "static/media/houses.839d807e.jpg";